export * from './apply-loan/applyLoan.component';
export * from './forget-password/forget-password.component';
export * from './login/login.component';
export * from './signup/signup.component';